import Typography from '@serko/zui/es/Typography';
import { TypographyProps } from '@serko/zui/es/Typography/Typography';
import React, { FunctionComponent } from 'react';
import pure from 'recompose/pure';

interface OwnProps extends TypographyProps {}

export interface ColumnLabelTextProps extends OwnProps {}

const ColumnLabelTextBase: FunctionComponent<ColumnLabelTextProps> = props => (
  <Typography variant="body1" color="textSecondary" lineClamp {...props} />
);

export const ColumnLabelText = pure(ColumnLabelTextBase);

ColumnLabelText.displayName = 'ColumnLabelText';
